import React from "react";
import "./sectionFour.css";
import SectionSpacer from "../SectionSpacer/SectionSpacer";
import { Link } from "react-router-dom";

const SectionFour = () => {
  return (
    <div>
      <SectionSpacer />
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&family=Satisfy&display=swap');`}
      </style>

      <div className="sectionFourContainerOne">
        <div className="dm-automation-section-four">
          <span className="highlighted-text">
            <span className="gradient-text">Instagram</span> Restrictions Are...
          </span>
        </div>
        <div className="dm-automation-section-four">
          <span className="highlighted-text-anymore">
            Not Your Limitations <span className="accent-text">Anymore </span>
          </span>
        </div>
        <div className="caption-text-section-four">
          <div className="dm-pointer-section-four">
            <p className="large-text">Just</p>
            <p className="App-logo-font logo-text">RAWGR</p>
            <p className="large-text">That !</p>
          </div>
        </div>
      </div>
      
      {/* Copyright Section */}
      <div className="copyright-section">
        <p className="copyright-text">&copy; {new Date().getFullYear()} RAWGR. All Rights Reserved.</p>
        <Link to="/privacy-policy" className="privacy-policy-button">Privacy Policy</Link>
        </div>
    </div>
  );
};

export default SectionFour;
